import { createFileRoute, useSearch  } from "@tanstack/react-router";
import { ErrorTransaction } from "@/components/wallet/TransactionStatuses/ErrorTransaction/ErrorTransaction";
import { z } from "zod";

const schema = z.object({
  key: z.string().optional()
});

export const Route = createFileRoute("/_mainLayout/wallet/transaction-error/")({
  component: RouteComponent,
  validateSearch: schema
});

function RouteComponent() {
  const params = useSearch({ from: "/_mainLayout/wallet/transaction-error/" });
  return (
    <ErrorTransaction
      transactionKey={params.key}
    />
  );
}
